import React from "react";

export class Range extends React.Component {
    constructor(props) {
        super(props);
        
        this.update = this.update.bind(this);
        this.reset = this.reset.bind(this);
    }

    update(e) {
        this.props.edit(this.props.index, "scale", e.target.value);
    }

    reset() {
        this.props.edit(this.props.index, "scale", 1);
    }

    render() {
        return (
            <div className={"range-slider " + this.props.name} onDoubleClick={this.reset}>
                <input 
                    type="range" 
                    name={this.props.name} 
                    min={this.props.min}
                    max={this.props.max}
                    step={this.props.step}
                    value={this.props.value}
                    onChange={this.update}
                />

                <span className="label give-tooltip" onClick={this.reset} data-tooltip="Reset scale">
                    {this.props.value}x
                </span>
            </div>
        );
    }
}
